import "../../lib/frst-timeline/frst-timeline";

(function () {

    document.addEventListener("DOMContentLoaded", init, { once: true });

    function init() {

        $(document).on("click", "#btn-search", function (e) {
            e.preventDefault();
            e.stopPropagation();

            var searchString = $("#searchString").val();

            getSearchResults(searchString);

        });

        $(document).on('input', '#searchString', function () {
            console.log("on intput of #searchString");
            if ($(this).val() === '') {
                hideSearchResults();
            }
        });

        // search on keypress of Enter too
        $(document).on("keypress", "#searchString", function (e) {
            if (e.key == "Enter") {
                var searchString = $("#searchString").val();

                getSearchResults(searchString);
            }
        });

        // enable timeline settings for timeline story
        if ($("#PortsideTimeline_v1").length > 0) {
            initTimeline();
        }

        function initTimeline() {
            $("#Timeline_Clone_v1 > div").appendTo("#PortsideTimeline_v1");
        }
    }

    function showSearchResults(html) {
        $("#searchResults .stories-wrapper").empty().append(html);
        $("#storyMain").hide();
        $("#searchResults").show();
        $(".btn-close-search-results").show();
    }

    function hideSearchResults() {
        $("#storyMain").show();
        $("#searchResults").hide();
        $("#searchString").val("");
        $("#searchResults .stories-wrapper").empty();
        $(".btn-close-search-results").hide();
    }

    function getSearchResults(searchString) {

        // start = 0 and take = 0 will return all
        $.ajax({
            url: "/Portside/Search",
            data: { start: 0, take: 0, searchString: searchString },
            success: function (html) {

                if (html == "") {
                    showSearchResults("<div class='text-center w-100'><p>We couldn't find anything that matched, please try again.</p><div>");
                } else {
                    showSearchResults(html);
                }

            },
            error: function (xhr) {
                if (self.options.debug === 'True') {
                    console.log("Error");
                    console.log(xhr);
                }
            }
        })
    }

})();